import React, { Component } from 'react';
import ContractBase from './ContractBase';

class RemisePreview extends Component {
    state = {  }
    render() {
        return (
            <ContractBase
                opType={"REMISE"}
                {...this.props}
            />
        );
    }
}

export default RemisePreview;